// extracted by mini-css-extract-plugin
module.exports = {"card":"Stats_card__vk5KT","sortBy":"Stats_sortBy__qtyS3","label":"Stats_label__7GHVo","button":"Stats_button__NoCeJ","icon":"Stats_icon__Ln_yp"};